import { useEffect } from 'react';

type Handlers = {
  onSearch?: () => void; // Ctrl/Cmd+K
  onConfirm?: () => void; // Ctrl/Cmd+Enter
  onCancel?: () => void; // Escape
};

/** Part F global behaviour — Ctrl+K = search, Ctrl+Enter = confirm, Esc = close. */
export function useKeyboardShortcuts(h: Handlers) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const mod = e.metaKey || e.ctrlKey;
      if (mod && e.key.toLowerCase() === 'k' && h.onSearch) {
        e.preventDefault();
        h.onSearch();
      } else if (mod && e.key === 'Enter' && h.onConfirm) {
        e.preventDefault();
        h.onConfirm();
      } else if (e.key === 'Escape' && h.onCancel) {
        h.onCancel();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [h]);
}
